import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import Link from 'components/shared/link';

import CheckIcon from './images/check.inline.svg';

export const BUTTON_STATES = {
  DEFAULT: 'default',
  LOADING: 'loading',
  SUCCESS: 'success',
  DISABLED: 'disabled',
  ERROR: 'error',
};

const styles = {
  // TODO: Remove outline only on focus, not on focus-visible
  base: 'inline-flex items-center justify-center text-center text-[14px] font-sans2 font-medium tracking-wide rounded-full leading-none cursor-pointer outline-none transition-colors duration-200 xl:text-[12px]',
  size: {
    md: 'h-14 px-8 xl:h-12 xl:px-7',
    medium: 'h-12 px-7',
    sm: 'h-11 px-7 xl:px-5',
    xs: 'h-8 px-4',
  },
  theme: {
    black: 'bg-black text-white hover:bg-[#433d3d] focus-visible:bg-[#433d3d]',
    white: 'bg-white text-black hover:bg-gray-1 focus-visible:bg-gray-1',
    'secondary-2': 'bg-secondary-2 text-white hover:bg-blue-hover focus-visible:bg-blue-hover',
    'secondary-2-border':
      'bg-white border-2 border-secondary-2 text-secondary-2 hover:bg-gray-1 hover:border-[#4659b9] hover:text-[#4659b9] focus-visible:bg-gray-1 focus-visible:border-[#4659b9] focus-visible:text-[#4659b9]',
    disabled: 'bg-gray-4 text-gray-6',
  },
};

const Button = ({ className, to, size, theme, state, children, ...otherProps }) => {
  const Tag = to ? Link : 'button';

  let content = null;

  switch (state) {
    case BUTTON_STATES.LOADING:
      content = (
        <div className="h-7 w-7 animate-spin rounded-full border border-b border-transparent border-b-white" />
      );
      break;
    case BUTTON_STATES.SUCCESS:
      content = <CheckIcon className="w-7" />;
      break;
    case BUTTON_STATES.DEFAULT:
    default:
      content = children;
  }

  return (
    <Tag
      className={clsx(styles.base, styles.size[size], styles.theme[theme], className, {
        'pointer-events-none':
          state === BUTTON_STATES.LOADING ||
          state === BUTTON_STATES.SUCCESS ||
          state === BUTTON_STATES.DISABLED,
      })}
      to={to}
      {...otherProps}
    >
      {content}
    </Tag>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(styles.size)),
  theme: PropTypes.oneOf(Object.keys(styles.theme)),
  state: PropTypes.oneOf(Object.values(BUTTON_STATES)),
  children: PropTypes.node.isRequired,
};

Button.defaultProps = {
  className: null,
  to: null,
  size: null,
  theme: null,
  state: BUTTON_STATES.DEFAULT,
};

export default Button;
